import languageUtils from '$common/utils/language';
import languageMessages from './language-messages';
import elementLocale from 'element-ui/lib/locale'
// 国际化语言配置
// 项目语言包
//  从 navigator 里先获取语言
const navigatorLanguage = languageUtils.getPageHeaderCurrentLanguage;
const locale = navigatorLanguage.indexOf('km') !== -1 ? 'km' : navigatorLanguage.indexOf('zh') !== -1 ? 'zh' : 'en';
// const locale = 'en';
export default {
  use: (Vue, VueI18n) => {
    Vue.use(VueI18n);
    //  初始化 i18n 对象
    const i18n = new VueI18n({
      locale, // 设置语言环境
      fallbackLocale: locale,
      messages: languageMessages,
      silentTranslationWarn: process.env.NODE_ENV === 'development' // 禁止没匹配警告
    });
    // TODO elementUI国际化失效
    elementLocale.i18n((key, value) => i18n.t(key, value))
    return {
      i18n
    };
  }
}
